<template>
  <el-card>
    <lang-form :data="detailInfo" @confirm="handleSubmit" />
  </el-card>
</template>

<script>
import {request} from "@/config/request";
import LangForm from "@/components/lang-form/LangForm";

export default {
  name: "LangEdit",
  components: {LangForm},
  data()  {
    return {
      detailInfo: {}
    }
  },
  methods: {
    async handleSubmit(data) {
      try {
        const params = Object.assign(this.detailInfo, data);
        delete params.createTime;
        delete params.updateTime;
        await request(this.$api.areaLanguageSet.update, params);
        this.$message.success("操作成功");
        this.$router.back();
      } catch (e) {
        console.log(e);
      }
    },
    async loadDetail() {
      try {
        const res = await request(this.$api.areaLanguageSet.detail, this.$route.query);
        this.detailInfo = res.areaLanguageSet;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>



</style>
